import { OAUTH_USER_TOKEN, PICO_API_URL } from '@piconetworks/endpoints'

const networkMiddleware = {
    accessTokenAdapters: {
        response: ({ data }) => ({
            access_token: data.token,
            refresh_token: data.refresh_token,
        }),
    },
    refreshTokenAdapters: {
        request: (params = {}) => {
            const { refresh_token: refreshToken, state } = params

            const publisherId = state?.zoid?.xprops?.publisherId

            const headers = {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                refreshtoken: refreshToken,
                publisherId,
            }

            return {
                method: 'get',
                baseURL: PICO_API_URL(),
                url: OAUTH_USER_TOKEN(),
                headers,
                timeout: 30000,
            }
        },
        response: ({ data }) => ({
            access_token: data.token,
            refresh_token: data.refresh_token,
        }),
    },
}

export default networkMiddleware
